import { Game } from './Game.js';

// Create and initialize the game
const game = new Game();
game.init();
game.animate(); 